import React, { useState, useEffect, useRef } from 'react';
import {
	Form,
	Input,
	Row,
	Col,
	Typography,
	DatePicker,
	Radio,
	Divider,
	Button,
	Select,
} from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import { NumberInput, RegexInput, formatMobileNumber } from 'shared_components/pattern_input';
import HttpCodeMessage from 'shared_components/message_http_status';
import PageTitle from 'shared_components/page_title';
import DonorRegSteps from '../DonorRegSteps';
import { useHistory } from 'react-router-dom';

const { Text } = Typography;
const { Option } = Select;

function Questionnaire(props) {
	const history = useHistory();

	useEffect(() => {}, []);

	const onFinish = async formData => {
		history.push('/bloodbank/donor_registration/step/5');
	};

	return (
		<div>
			<PageTitle pageTitle="QUESTIONNAIRE" />
			<DonorRegSteps activeIndex={4} />
			<div className="space-y-md"></div>
			<Form
				initialValues={{}}
				onFinish={onFinish}
				className="donor-rigistration-clr-fillup-form"
				layout="vertical"
				style={{ marginTop: 10 }}
			>
				<div className="container">
					<div className="divider">
						<Divider className="line" type="vertical" />
					</div>
					<div className="divider">
						<Divider className="line" type="vertical" />
					</div>
				</div>
				<Row justify="end" style={{ width: '100%', maxWidth: '1600px', margin: '0 auto' }}>
					<div className="buttons">
						<Link to={'/bloodbank/donor_registration/step/3'}>
							<Text>
								<u>BACK</u>
							</Text>
						</Link>
						<Button type="primary" shape="round" style={{ width: 120 }} htmlType="submit">
							NEXT STEP
						</Button>
					</div>
				</Row>
			</Form>
		</div>
	);
}

export default Questionnaire;
